import { type Lesson } from "@core/grades/types";
import { trans, plainTrans } from "@mongez/localization";
import { LightningBoltIcon } from "@radix-ui/react-icons";
import { LessonsCarousel } from "./LessonsCarousel";

type LatestLessonsSectionProps = {
  lessons: Lesson[];
  className?: string;
  iconColor?: string;
};

export function LatestLessonsSection({
  lessons,
  className,
  iconColor = "text-yellow-600",
}: LatestLessonsSectionProps) {
  if (!lessons?.length) return null;

  return (
    <LessonsCarousel
      title={plainTrans("home.latestLessons")}
      lessons={lessons}
      className={className}
      icon={<LightningBoltIcon className={`h-6 w-6 ${iconColor}`} />}
    />
  );
}
